import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import Header from "@/components/common/Header/header";
import TextField from "@/components/common/Input/TextField";
import { bankingStart, fetchData } from "@/lib/helper";
import React, { useEffect, useState } from "react";
import Div100vh from "react-div-100vh";
import { useNavigate } from "react-router-dom";
import ProcessDisbursal from "@/components/banking/ProcessDisbursal"; // Assuming this component exists
import { isNeutralLender, useLender } from "@/lib/lender";

export default function PennyDrop() {
  const [formData, setFormData] = useState({
    accountNumber: "",
    ifscCode: "",
  });
  const [data, setData] = useState(null);
  const [lenderKey, setLenderKey] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const navigate = useNavigate();
  const lender = useLender(lenderKey);

  useEffect(() => {
    const getData = async () => {
      try {
        const resData = await fetchData("journey/full");
        const userData = await fetchData("user/me");
        setLenderKey(resData?.journey?.lender);

        const bankingData = resData?.journey?.steps?.find(
          (step) => step.name === "BANKING"
        );

        const pennyDropData = resData?.journey?.steps?.find(
          (step) => step.name === "PENNY_DROP"
        );
        const bankingRefId = bankingData?.refId;
        const activeBank =
          userData?.banking.find((bank) => bank.refId === bankingRefId) || {};
        setData(activeBank);

        if (pennyDropData.status === "SUCCESS") navigate("/onboarding");

        if (activeBank.unmaskedAccountNumber && activeBank.ifscCode) {
          setFormData({
            accountNumber: activeBank.unmaskedAccountNumber,
            ifscCode: activeBank.ifscCode,
          });

          if (
            activeBank.pennyDropAttempts &&
            activeBank.pennyDropAttempts.length < 3
          ) {
            setIsProcessing(true);
            const response = await bankingStart("banking/penny-drop", {
              accountNumber: activeBank.unmaskedAccountNumber,
              ifscCode: activeBank.ifscCode,
              bankingRefId: activeBank.refId,
            });
            setIsProcessing(false);

            if (response.account_status === "active") {
              navigate(
                theme
                  ? `/b/${userIdentifier}?partner=${
                      theme.name || "housr"
                    }&step=onboarding`
                  : "/onboarding"
              );
            }
          } else {
            setShowErrorMessage(true);
          }
        } else if (
          activeBank.pennyDropAttempts &&
          activeBank.pennyDropAttempts.length >= 3
        ) {
          setShowErrorMessage(true);
        } else if (activeBank.ifscCode) {
          setFormData({
            ifscCode: activeBank.ifscCode,
          });
        }
      } catch (error) {
        console.error(
          "Error fetching journey data or processing penny drop",
          error
        );
        setIsProcessing(false);
      }
    };
    getData();
  }, [navigate]);

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSubmit = async () => {
    console.log("Submitting data:", formData);

    try {
      const response = await bankingStart("banking/penny-drop", {
        accountNumber: formData?.accountNumber,
        ifscCode: formData?.ifscCode,
        bankingRefId: data.refId,
      });
      if (response.account_status === "active") {
        navigate("/onboarding");
      } else {
        alert("Account validation failed. Please check your details.");
      }
    } catch (error) {
      console.error("Error submitting account details:", error);
      alert("An error occurred. Please try again.");
    }
  };

  if (isProcessing) {
    return <ProcessDisbursal />;
  }

  return (
    <Div100vh className="flex flex-col justify-start space-y-subheading-input px-8 py-8">
      <Header
        heading="Complete Account Verification"
        subheading="Complete the form below to verify your account"
      />
      <div>
        <TextField
          name="accountNumber"
          label={"Account Number"}
          value={formData?.accountNumber}
          onChange={(value) => handleInputChange("accountNumber", value)}
          required
          type="number"
          maxLength={16}
          consent
          disabled={showErrorMessage} // Disable if maximum attempts are reached
        />
        {data?.maskedAccountNumber && (
          <p className="text-xs text-gray-500">
            Please enter account number ending with digits as of{" "}
            {data?.maskedAccountNumber}
          </p>
        )}
      </div>

      <TextField
        name="ifscCode"
        label="IFSC Code"
        value={formData?.ifscCode ?? ""}
        onChange={(value) => handleInputChange("ifscCode", value)}
        required
        type="text"
        disabled={showErrorMessage || Boolean(data?.ifscCode)}
      />

      {showErrorMessage && (
        <p className="text-red-500 text-2xs mt-4">
          Maximum attempts for verification have been reached. Please contact
          our support team for further assistance or call directly at{" "}
          <a
            href="tel:+919354235813"
            className="text-blue-500 underline hover:text-blue-700"
          >
            +919354235813
          </a>
          .
        </p>
      )}

          <div className="flex flex-col items-center justify-center gap-2">
           <PrimaryButton
             text="Submit"
             handleClick={handleSubmit}
             disabled={showErrorMessage}
             loading={isLoading}
             // className={`${theme?.primaryButtonBgColor} ${theme?.primaryButtonTextColor}`}
           />
            {!isNeutralLender(lender) && (
            <div className="flex items-center justify-center">
                <span className="text-black text-2xs italic">powered by</span>
                 <img src={lender.logoUrl} alt={lender.legalName} className="inline-block max-h-4 ml-1"/>
               </div>
            )}
               </div>
    </Div100vh>
  );
}
